<template>
    <div>
        <div class="user-headline__container">
            <div class="user-headline__top">
                <h1 class="user-headline__title" :class="['user-headline__title', {'empty': empty}]" v-html="$t(title)"></h1>
                <slot></slot>
            </div>
            <p class="user-headline__description" v-if="description && !empty" v-html="$t(description)"></p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            description: String,
            empty: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .user-headline {
        &__container {
            display: flex;
            flex-direction: column;
            margin: 10px 0 40px;
            gap: 20px;

            [class*="mobile"] & {
                flex-direction: column;
                margin: 10px 0 0;
            }
        }

        &__top {
            display: flex;
            gap: 30px;
        }

        &__title {
            font-size: 2.2rem;

            &.empty {
                [class*="mobile"] & {
                    margin: 0 0 20px;
                }
            }

            [class*="desktop"] & {
                font-size: 3.2rem;
                margin: 0;
            }
        }

        &__description {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 1.6rem;
            line-height: 150%;

            [class*="mobile"] & {
                margin: 0 0 30px;
            }
        }
    }
</style>
